/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IGetStockResponse, LoadingPort } from '~/src/repositories/Stock/models/Stock'
import NoImage from '~/public/assets/no_image.png'
export function convertStock(data: any): IGetStockResponse {
  const items = data.items.map((item: any) => {
    const price = item?.stockType === 'Engine' ? Number(item?.withoutCatalystPrice) ? item?.withoutCatalystPrice : item?.withCatalystPrice : item?.originalPrice || 0
    let loadingPorts: LoadingPort[] = []
    if (item?.loadingPorts.length > 0) {
      item.loadingPorts.forEach((loadingPort: any) => {
        loadingPorts.push({
          id: loadingPort.id,
          name: loadingPort.name,
          order: loadingPort.order,
          transportationFee: loadingPort.transportationFee,
          loadingBaseFee: item.stockType === 'Engine' ? Number(item?.withoutCatalystPrice) ? loadingPort.loadingBaseFeeWithoutCat : loadingPort.loadingBaseFeeWithCat : loadingPort.loadingBaseFee || 0
        })
      })
    }
    return {
      id: item.id,
      photo: item?.images[0] ?? NoImage,
      refNo: item?.refNo ?? 'refNo',
      name: item?.displayName ?? 'name',
      category: item?.parentCategoryName ?? '',
      options: item?.tags ?? [],
      price: Math.floor(Number(price)),
      stockType: item?.stockType ?? '',
      loadingPorts: loadingPorts,
      supplier: item?.supplier ?? ''
    }
  })

  return {
    items,
    pagination: data.pagination,
  }
}
